module.exports = {
	"rounds": [
		{
			"text3": ""
		},
		{
			"text3": ""
		},
		{
			"text3": "To better your odds in making a profit and hitting targets, we highly recomend that you and your team spend some time analyzing the line items of prior rounds income statements and balance sheets to improve ROI outcomes (ROE and ROA)."
		},
		{
			"text3": "To better your odds in making a profit and hitting targets, we highly recomend that you and your team spend some time analyzing the line items of prior rounds income statements and balance sheets to improve ROI outcomes (EPS, ROE and ROA)."
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/onboarding/conduct-research.json
// module id = 1917
// module chunks = 0